import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {Text} from "@mantine/core";
import {ProductLineItem} from "../types.ts";
import TableFormattedTimestamp from '../../../utils/TableFormattedTimestamp.tsx';

export const useTableColumns = (
    {onRecordClick}: { onRecordClick: (record: ProductLineItem) => void },
) => {

    const columns: DataTableColumn<ProductLineItem>[] = [
        {
            accessor: 'productFeature.name',
            title: I18n.get('Feature'),
            render: (record: ProductLineItem) => (
                <Text
                    c="blue"
                    style={{cursor: 'pointer'}}
                    onClick={() => onRecordClick(record)}
                >
                    {record.productFeature?.name || 'Unknown Feature'}
                </Text>
            ),
        },
        {
            accessor: 'position',
            title: I18n.get('Position'),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            render: (record: ProductLineItem) => (
                <TableFormattedTimestamp record={record} propertyName="created"/>
            ),
        },
    ];

    return {
        columns,
    };
};
